// src/components/RichiediNFTab.js
// Scheda "Richiedi NF" dentro la singola commessa — stesso identico form e stesso elenco
// della pagina Personale (components/ElencoNF.js), con la commessa già fissata.
import React, { useState, useEffect } from "react";
import { collection, query, where, onSnapshot } from "firebase/firestore";
import { db } from "../firebase";
import { useAuth } from "../contexts/AuthContext";
import { useToast } from "../utils/Toast";
import { Plus, FileText } from "lucide-react";
import { FormNF } from "../pages/RichiediNFPage";
import ElencoNF from "./ElencoNF";

export default function RichiediNFTab({ projectId, projectName, codiceCommessa, orgId, projectData }) {
  const { currentUser } = useAuth();
  const commessaChiusa = projectData?.statoCommessa === "chiusa";
  const { addToast } = useToast();
  const [nfs, setNfs] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [editNf, setEditNf] = useState(null);

  useEffect(() => {
    if (!projectId) return;
    return onSnapshot(query(collection(db,"nuoveForniture"), where("commessaId","==",projectId), where("organizationId","==",orgId)), snap => {
      const lista = snap.docs.map(d=>({id:d.id,...d.data()}));
      lista.sort((a,b)=>(b.createdAt?.toMillis?.()||0)-(a.createdAt?.toMillis?.()||0));
      setNfs(lista);
    });
  }, [projectId, orgId]);

  const commessaFissa = { id:projectId, name:projectName, codiceCommessa };
  // Le bozze sono personali: in commessa si vedono le proprie e tutte quelle già inviate
  const visibili = nfs.filter(n => (n.statoRichiesta||"Da inviare") !== "Da inviare" || n.createdBy === currentUser?.uid);

  return (
    <div style={{padding:24}}>
      <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:20}}>
        <div>
          <h3 style={{fontSize:16,fontWeight:700}}>📋 Richiedi NF</h3>
          <div style={{fontSize:12,color:"#9ca3af",marginTop:2}}>{visibili.filter(n=>!n.eliminata).length} richiesta/e per questa commessa</div>
        </div>
        <button onClick={()=>{ if(commessaChiusa){addToast("Commessa chiusa — non è più possibile richiedere nuove forniture per questa commessa","error");return;} setShowForm(true); }} className="btn btn-primary" style={{display:"flex",alignItems:"center",gap:6}}>
          <Plus size={14}/> Nuova richiesta
        </button>
      </div>

      <ElencoNF nfs={visibili} orgId={orgId} currentUser={currentUser} mostraCommessa={false} onModifica={setEditNf} vuoto={(
        <div style={{textAlign:"center",padding:48,color:"#9ca3af"}}>
          <FileText size={40} style={{marginBottom:12,opacity:0.3}}/>
          <div style={{fontSize:14,fontWeight:600}}>Nessuna richiesta NF per questa commessa</div>
          <div style={{fontSize:13,marginTop:4}}>Crea una richiesta di Nuova Fornitura</div>
        </div>
      )}/>

      {showForm && <FormNF orgId={orgId} currentUser={currentUser} commessaFissa={commessaFissa} onClose={()=>setShowForm(false)}/>}
      {editNf && <FormNF orgId={orgId} currentUser={currentUser} nfEsistente={editNf} commessaFissa={commessaFissa} onClose={()=>setEditNf(null)}/>}
    </div>
  );
}
